import { render, staticRenderFns } from "./DeviceConfirm.vue?vue&type=template&id=cb515d70&scoped=true&"
import script from "./DeviceConfirm.vue?vue&type=script&lang=js&"
export * from "./DeviceConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb515d70",
  null
  
)

export default component.exports